<script>
export default {
  HTTP_SUCCESS: 200,

  //系统开关 0：正常
  SYS_NORMAL_ENABLE: '0',
  //系统开关 1：停用
  SYS_NORMAL_DISABLE: '1',

  //处理状态 1：已处理
  HANDLE_STATE_PROCESSED: '1',
  //处理状态 2：未处理
  HANDLE_STATE_UNTREATED: '2',

  //审核状态 0：待处理
  EXAMINE_STATUS_WAIT: '0',
  //审核状态 1：已处理
  EXAMINE_STATUS_PASS: '1',
  //审核状态 2：未处理
  EXAMINE_STATUS_REFUSE: '2',

  //竞价项目进行状态 0：未发布
  PROJECT_BIDDING_NO_PUBLISH: "0",
  //竞价项目进行状态 1：未开始
  PROJECT_BIDDING_NO_STARTED: "1",
  //竞价项目进行状态 2：准备中
  PROJECT_BIDDING_PREPARE: "2",
  //竞价项目进行状态 3：竞价中
  PROJECT_BIDDING_BIDDING: "3",
  //竞价项目进行状态 4：加速竞价中
  PROJECT_BIDDING_ACC_BIDDING: "4",
  //竞价项目进行状态 5：已结束
  PROJECT_BIDDING_ENDED: "5",

  // 公告发布状态 1：已发布
  PUBLISH_STATUS_PUBLISHED: "1",
  // 公告发布状态 2：未发布
  PUBLISH_STATUS_UNPUBLISHED: "2",

  // 成交状态 0：未成交
  DEAL_STATUS_NO_DEAL: "0",
  // 成交状态 1：已成交
  DEAL_STATUS_ALREADY_DEAL: "1",
  // 成交状态 2：已流拍
  DEAL_STATUS_UNBID: "2",

  // 表单新增
  FORM_ADD: "1",
  // 表单修改
  FORM_UPDATE: "2",

  SERVER_URL: 'https://file.jjtbp.com',
  SERVER_WS: 'wss://admin.jjtbp.com/prod-api',
};
</script>
